import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { layout, mediaQueries } from 'src/shared/styles/variables';
import { navigationService } from 'src/config/rootService';
import tada from 'src/public/img/tada.svg';
import { HeadingText50, BodyTextMedium, Button } from '@modernhealth/vital-components';

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
});

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 30,
    maxWidth: layout.containerBiggerWidth,
    maxHeight: 'auto',
    alignItems: 'center',
    whiteSpace: 'pre',
    [mediaQueries.sm]: {
        marginTop: 10,
    },
});

const Image = styled.img({
    marginTop: '12rem',
    [mediaQueries.sm]: {
        marginTop: '4rem',
    },
});

const ButtonContainer = styled.div({
    marginTop: '2rem',
});

const WorkWithPammProviderRequestedPage: FC = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <Wrapper>
                <Image src={tada} alt={t('providers:pamm_provider.request.submitted.title')} />
                <HeadingText50>
                    {t('providers:pamm_provider.request.submitted.title')}
                </HeadingText50>
                <BodyTextMedium centered>
                    {t('providers:pamm_provider.request.submitted.description', {
                        email: 'help@joinmodernhealth.com',
                    })}
                </BodyTextMedium>
                <ButtonContainer>
                    <Button
                        variant="secondary"
                        size="medium"
                        onClick={() => navigationService.navigate('/dashboard')}
                    >
                        {t('providers:pamm_provider.request.submitted.back.button')}
                    </Button>
                </ButtonContainer>
            </Wrapper>
        </Container>
    );
};

export default WorkWithPammProviderRequestedPage;
